export default "__VITE_ASSET__70ICshrr__"